/**
 * The anonymous login calls, bound to this build's API origin. The calls
 * themselves are shared with the native app (@fsv/data, loginApi.ts).
 */
import { createLoginApi } from '@fsv/data';
import { config } from '../config';

export { LoginError } from '@fsv/data';

const login = createLoginApi({ baseUrl: config.apiBaseUrl });

export const requestCode = login.requestCode;
export const verifyCode = login.verifyCode;
